// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getLinkedOrderDifferences () {

    const endPoint = `${basePath}/linked-orderdifferences`;

    const options = {
        body: JSON.stringify(),
        headers: {'Content-Type': 'application/json'},
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}
